import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_empresa/empresa-contas-a-pagar-main";

export const Route = createFileRoute("/_authenticated/contas")({
  head: () => ({
    meta: [
      { title: "Contas a pagar — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Contas a pagar da loja: fornecedores, franquia, contas de consumo, folha de pagamento, aluguéis e despesas extras.",
      },
      { property: "og:title", content: "Contas a pagar — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Contas a pagar da loja: fornecedores, franquia, contas de consumo, folha de pagamento, aluguéis e despesas extras.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
